// @flow

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SignUpForm from 'components/organisms/SignUpForm'
import { actions as accountActions } from 'redux/modules/account'
import { setUIState, containerIds } from 'redux/modules/ui'
import { Redirect } from 'react-router-dom'
import withRest from 'frontend_core/dist/api/rest/withRest'
import AccountUseCase, {
  type AccountUseCaseType,
} from 'usecases/AccountUseCase'

type Props = {
  accountUseCase: AccountUseCaseType,
  account: {
    email: string,
  },
  ui: {
    canSubmit: boolean,
  },
}

class SignUpFormContainer extends React.Component<Props> {
  componentDidMount() {
    const { accountUseCase } = this.props
    accountUseCase.configRecaptcha()
  }

  onSelectProfileImage = (files) => {
    const { accountUseCase } = this.props
    const file = files[0]
    accountUseCase.setAccountState('profileImage', file.preview)
    accountUseCase.setAccountState('profileImageFile', file)
  }

  render() {
    const { account, ui, accountUseCase } = this.props
    return account.isSuccess ? (
      <Redirect to={'/sign_up/sent'} />
    ) : (
      <SignUpForm
        account={account}
        ui={ui}
        onSubmit={accountUseCase.signUp}
        onChange={accountUseCase.inputSignUpForm}
        onSelectProfileImage={this.onSelectProfileImage}
        canSubmit={ui.canSubmit}
      />
    )
  }
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    signUp: accountActions.signUp,
    setAccount: accountActions.setAccount,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRest(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AccountUseCase(SignUpFormContainer)),
)
